import { useEffect, useState } from "react";
import { END_POINTS } from "../../Helper/Constant";
import { getApiRequest } from "../../services/getApiRequest";
import { postApiRequest } from "../../services/postApiRequest";

let cachedEmojis = null;
let inflight = null;

export const fetchAllowedEmojis = async () => {
  if (Array.isArray(cachedEmojis) && cachedEmojis.length) {
    return cachedEmojis;
  }
  if (inflight) return inflight;

  inflight = getApiRequest(END_POINTS.CHAT_REACTIONS_ALLOWED_EMOJIS)
    .then((response) => {
      const list = Array.isArray(response?.allowedEmojis)
        ? response.allowedEmojis
        : Array.isArray(response?.data?.allowedEmojis)
          ? response.data.allowedEmojis
          : [];
      cachedEmojis = list.filter(Boolean);
      return cachedEmojis;
    })
    .catch(() => cachedEmojis || [])
    .finally(() => {
      inflight = null;
    });

  return inflight;
};

export const setAllowedEmojisCache = (emojis = []) => {
  cachedEmojis = Array.isArray(emojis) ? emojis.filter(Boolean) : [];
  return cachedEmojis;
};

export const saveAllowedEmojis = async (emojis = []) => {
  const response = await postApiRequest(END_POINTS.CHAT_REACTIONS_ALLOWED_EMOJIS, {
    emojis,
  });
  const list = Array.isArray(response?.allowedEmojis)
    ? response.allowedEmojis
    : emojis;
  return setAllowedEmojisCache(list);
};

const useAllowedEmojis = () => {
  const [allowedEmojis, setAllowedEmojis] = useState(cachedEmojis || []);
  const [loading, setLoading] = useState(!cachedEmojis);

  useEffect(() => {
    let mounted = true;
    setLoading(!cachedEmojis);
    fetchAllowedEmojis().then((list) => {
      if (mounted) {
        setAllowedEmojis(list);
        setLoading(false);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  return { allowedEmojis, loading };
};

export default useAllowedEmojis;
